import {
	useRef,
	useState,
	RefObject,
	useReducer,
	useEffect,
	KeyboardEvent,
	FocusEvent,
	FormEvent,
	FC
}
	from "react"
import {
	Tab,
	Tabs,
	Button,
	Modal
}
	from "react-bootstrap"
import {
	Navigate,
	useNavigate
}
	from "react-router-dom"
import {
	useDispatch,
	useSelector
}
	from "react-redux"

import {
	RootState,

	enableIdleLockSwitch,
	disableIdleLockSwitch,

	displayNotice,
	setSessionToken,
	setCurrentUserRole,
	setCampusRef,
	setCurrentUserCampus,
	setCurrentUserCampusId,

	setUserMenu,
	setMenuRef,
	setNavigation
}
	from "./../../globals"
import {
	baseMenu,
	baseNavigation,
	studentMenu,
	studentNavigation,
	basicSetup,
	buttonClickHandling,
	keyHandling,
	generateSectionMap,
	isEmpty,
	useForm,
	validateField
}
	from "./../../common"
import AuthService
	from "./../../services/auth.service"

import "./style.css"
import {
	UserState,
	setAllowedCampuses,
	setCurrentCampus,
	setCurrentCampusId,
	setCurrentRole,
	setRoles,
	setUser,
	setPermissions,
	handleLogout
} from "../../redux/reducers/sessionReducer"
import {
	setCampuses,
	setCurrencies,
	setEnrollmentStatuses,
	setPaymentMethods,
	setPaymentStatuses,
	setInvoiceStatuses,
	setRecipientAccounts
} from "../../redux/reducers/catalogReducer"
import HttpManager from "../../services/HttpManager"
import { CATALOG } from "../../constants"
import { useAxiosInterceptor } from "../../services/v2/axiosInstance"
import { anotarDuenoDelToken, leerMotivoDeSalida, leerCodigoDeSalida, olvidarMotivoDeSalida, tomarDestino } from "../../guardiaDeSesion"
import { aterrizajeHecho } from "../../utils/rolesDeBase"
import { marcarCambioDeClave } from "../../cambioDeClave"
import RecuperarPorCodigo from "./recuperarPorCodigo"
import { EntrarConWhatsApp, Invitacion, ElegirCuenta, Seleccion } from "./accesoAlumno"

/*
	A dónde ir después de entrar. Un enlace directo guardado (wapp.volverA) gana sobre el aterrizaje por rol
	(Profesor → Asistencias, asesoras → CRM): si trae enlace, el Panel ya no la redirige (utils/rolesDeBase.ts).
*/
const destinoTrasEntrar = (): string => {
	const d = tomarDestino()
	if (d !== "/") aterrizajeHecho()
	return d
}

type LoginState =
	{
		isLoginButtonDisabled: boolean
	}

type RegisterState =
	{
		isRegisterButtonDisabled: boolean
	}

type PwdResetState =
	{
		isPwdResetButtonDisabled: boolean
	}

interface User {
	firstName: string;
	lastName: string;
	email: string;
	password: string;
	passwordConfirm: string;
	regEmail: string;
	regConfirmPassword: string;
}

const initialLoginState: LoginState =
{
	isLoginButtonDisabled: true
}

const initialRegisterState: RegisterState =
{
	isRegisterButtonDisabled: true
}

const initialPwdResetState: PwdResetState =
{
	isPwdResetButtonDisabled: true
}

type LoginAction = { type: "setIsLoginButtonDisabled", payload: boolean }
type RegisterAction = { type: "setIsRegisterButtonDisabled", payload: boolean }
type PwdResetAction = { type: "setIsPwdResetButtonDisabled", payload: boolean }
const loginReducer = (state: LoginState, action: LoginAction): LoginState => {
	switch (action.type) {
		case "setIsLoginButtonDisabled":
			return { ...state, isLoginButtonDisabled: action.payload }
			break;
	}
}

const registerReducer = (state: RegisterState, action: RegisterAction): RegisterState => {
	switch (action.type) {
		case "setIsRegisterButtonDisabled":
			return { ...state, isRegisterButtonDisabled: action.payload }
			break;
	}
}

const pwdResetReducer = (state: PwdResetState, action: PwdResetAction): PwdResetState => {
	switch (action.type) {
		case "setIsPwdResetButtonDisabled":
			return { ...state, isPwdResetButtonDisabled: action.payload }
			break;
	}
}

const Access: FC = () => {
	useAxiosInterceptor();
	const http = HttpManager.getInstance();
	const [loginState, loginTrigger] = useReducer(loginReducer, initialLoginState)
	const [registerState, registerTrigger] = useReducer(registerReducer, initialRegisterState)
	const [pwdResetState, pwdResetTrigger] = useReducer(pwdResetReducer, initialPwdResetState)
	const dispatch = useDispatch()
	const navigate = useNavigate()
	// Enlace directo abierto sin sesión: a dónde va después de entrar (lo comparten el login y la redirección de abajo).
	const destino = useRef<string | null>(null)
	const authenticated: boolean = useSelector((state: RootState) => state.authenticated.value)
	const userMenu: any = useSelector((state: RootState) => state.userMenu.value)
	const navigation: any = useSelector((state: RootState) => state.navigation.value)
	const idleLocked: any = useSelector((state: RootState) => state.idleLockSwitch.value)
	const basicInfo: any = useSelector((state: RootState) => state.basicInfo.value)
	const userData: UserState | null = useSelector((state: RootState) => state.rootReducer.sessionState.user);
	const allowedCampuses: any[] = useSelector((state: RootState) => state.rootReducer.sessionState.allowedCampuses);
	const currentCampusId: number = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampusId);
	const currentCampus: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampus);
	const campuses: any[] = useSelector((state: RootState) => state.rootReducer.catalog.campuses);
	let focusInputEmail = useRef<HTMLDivElement>(null)
	let focusInputRecover = useRef<HTMLDivElement>(null)
	let focusInputPass = useRef<HTMLDivElement>(null)
	let focusInputPassConfirm = useRef<HTMLDivElement>(null)
	let focusInputFirstName = useRef<HTMLDivElement>(null)
	let focusInputLastName = useRef<HTMLDivElement>(null)
	let focusLabelEmail = useRef<HTMLLabelElement>(null)
	let focusLabelFirstName = useRef<HTMLLabelElement>(null)
	let focusLabelLastName = useRef<HTMLLabelElement>(null)
	let focusLabelRecover = useRef<HTMLLabelElement>(null)
	let focusLabelPass = useRef<HTMLLabelElement>(null)
	let focusLabelPassConfirm = useRef<HTMLLabelElement>(null)
	let divUserNoExist = useRef<HTMLDivElement>(null)
	let lastNameRef = useRef<HTMLInputElement>(null)
	let firstNameRef = useRef<HTMLInputElement>(null)
	let emailRef = useRef<HTMLInputElement>(null)
	let emailRegRef = useRef<HTMLInputElement>(null)
	let recoverRef = useRef<HTMLInputElement>(null)
	let passwordRef = useRef<HTMLInputElement>(null)
	let passwordConfirmRef = useRef<HTMLInputElement>(null)
	let loginRef = useRef<HTMLInputElement>(null)
	let registerRef = useRef<HTMLInputElement>(null)
	let pwdResetRef = useRef<HTMLButtonElement>(null)
	let loginFormRef = useRef<HTMLFormElement>(null)
	let registerFormRef = useRef<HTMLFormElement>(null)
	let pwdResetFormRef = useRef<HTMLFormElement>(null)
	const [focusedElement, setFocusedElement] = useState<any>(null)
	const [show, setShow] = useState<boolean>(false)
	const [currentTab, setCurrentTab] = useState<string | null>("login")
	//Primera vez: el servidor ya mandó el código por WhatsApp al intentar entrar; se abre directo en "escribe tu código".
	const [codigoInicial, setCodigoInicial] = useState<{ email: string, aviso: string } | null>(null)
	//Entrar con WhatsApp (alumnos, 2026-10-21): de dónde viene (botón, Olvidé, invitación usada/vencida) y qué trae escrito.
	const [whatsapp, setWhatsapp] = useState<{ modo: "entrar" | "olvide", telefono?: string, pais?: "mx" | "hn", aviso?: string, n: number }>({ modo: "entrar", n: 0 })
	const [invitacion, setInvitacion] = useState<string>("")
	//Número + contraseña que coincide en varias cuentas del mismo número: se escoge (2026-10-21).
	const [seleccion, setSeleccion] = useState<Seleccion | null>(null)
	const abrirWhatsapp = (modo: "entrar" | "olvide", extra: { telefono?: string, pais?: "mx" | "hn", aviso?: string } = {}) => {
		setWhatsapp((w) => ({ modo, ...extra, n: w.n + 1 }))
		setCurrentTab("whatsapp")
	}
	//Filled from the link in the "restablecer contraseña" email: /access?token=...&email=...
	const [resetParams, setResetParams] = useState<{ token: string, email: string }>({ token: "", email: "" })
	let pwdResetConfirmRef = useRef<HTMLInputElement>(null)
	let pwdResetConfirmFormRef = useRef<HTMLFormElement>(null)

	useEffect(() => {
		const params = new URLSearchParams(window.location.search)
		const token = params.get("token")
		const email = params.get("email")

		if (token && email) {
			setResetParams({ token, email })
			setCurrentTab("pwdResetConfirm")
		}

		//Invitación personal al portal (WhatsApp): /access?invitacion=<token>. Se quita de la barra para que no quede
		//en el historial ni se comparta por accidente; el token sigue en memoria mientras la pantalla esté abierta.
		//Recargar la página no pierde la invitación: se guarda en esta pestaña hasta entrar (QA 2026-10-21).
		let invitacionToken = params.get("invitacion")
		try {
			if (invitacionToken) sessionStorage.setItem("wapp.invitacion", invitacionToken)
			else invitacionToken = sessionStorage.getItem("wapp.invitacion")
		} catch (_) { /* sin almacenamiento */ }
		if (invitacionToken) {
			setInvitacion(invitacionToken)
			setCurrentTab("invitacion")
			window.history.replaceState({}, "", window.location.pathname)
		}

		//Si llegamos aquí porque la sesión murió, se explica por qué (tope de dispositivos,
		//vencimiento, inactividad) con el texto que mandó el servidor.
		//Quien abre su invitación no viene de una sesión cerrada: un aviso viejo de esta pestaña solo confundiría.
		if (invitacionToken) olvidarMotivoDeSalida()
		const motivo = invitacionToken ? null : leerMotivoDeSalida()

		if (motivo) {
			//Alumno con una sola sesión: la cerró su propia entrada en otro equipo (2026-10-21).
			const otroDispositivo = leerCodigoDeSalida() === "sesion_otro_dispositivo"
			dispatch(displayNotice({
				cornerClose: true,
				message: motivo,
				heading: <h3 style={{ color: "var(--wa-tinta)", display: "inline-block" }}>
					{otroDispositivo ? "Entraste Desde Otro Dispositivo" : "Tu sesión se cerró"}
				</h3>
			}))
		}
	}, [])

	const fetchRecipientAccounts = async () => {
		try {
			const response = await http.recipientAccountService.getRecipientAccounts();
			return response.data;
		} catch (err: any) {
			console.error(err);
		}
	}

	const fetchPaymentMethodsByCountry = async (countryId: number) => {
		try {
			const response = await http.paymentMethodService.getPaymentMethodsByCountry(countryId);
			dispatch(setPaymentMethods(response.data));
		} catch (err: any) {
			console.error(err);
		}
	}

	const fetchCampuses = async () => {
		try {
			const response = await http.campusService.getCampuses();
			return response.data;
		} catch (err: any) {
			console.error(err);
		}
	}

	const fetchCatalogData = async () => {
		//Un alumno no puede leer los catálogos de administración (403): sin esto esta limpieza lo tomaba por una sesión
		//vieja y le borraba la sesión recién abierta (Portal del alumno, 2026-10-16).
		if (localStorage.getItem("currentRole") === "student") return
		if (userData && userData.token) {
			const [
				campuses,
				recipientAccounts,
			] = await Promise.all([
				fetchCampuses(),
				fetchRecipientAccounts(),
			]);

			//A persisted session whose token is no longer valid (expired, or revoked by a password reset) makes these
			//requests fail; drop the stale session instead of crashing the login page.
			if (!campuses || !allowedCampuses || allowedCampuses.length === 0) {
				dispatch(handleLogout())
				localStorage.removeItem("persist:root")
				localStorage.removeItem("accessToken")
				return
			}

			dispatch(setCampuses(campuses));
			dispatch(setCurrentCampusId(allowedCampuses[0].id));
			const campus = campuses
				.find((c: any) => c.id === (currentCampusId > 0 ? currentCampusId : allowedCampuses[0].id));
			dispatch(setCurrentCampus(campus));
			dispatch(setRecipientAccounts(recipientAccounts));
			fetchPaymentMethodsByCountry(campus.countryId);
		}
	}

	useEffect(() => {
		// if (userData && userData.token) {
			fetchCatalogData();
		// }
	}, [userData]);

	const access = (data: any) => {
		let assignedNavigation
		let menu
		let menuMap: any = {}
		let campusIndex: any = {}
		let user = data.user

		if (user.roles && user.roles.length > 0) {
			user.currentRole = user.initialRole.code
			const [complementaryMenu, complementaryNavigation] = generateSectionMap(user)
			menu = [...baseMenu, ...complementaryMenu]
			assignedNavigation = [...baseNavigation, ...complementaryNavigation]

			if (user.roleMap[user.currentRole].campuses && user.roleMap[user.currentRole].campuses.length > 0) {
				let refIndex: string

				user.roleMap[user.currentRole].campuses.map
					(
						(campus: any) => {
							refIndex = "C_" + campus.id
							campusIndex[refIndex] = { ...campus, refIndex: refIndex }

							return
						}
					)

				user.roleMap[user.currentRole].campusRef = campusIndex
			}
		}
		else {
			menu = baseMenu
			assignedNavigation = baseNavigation

			if (user.student) {
				let refIndex: string
				user.currentRole = "student"
				menu = studentMenu
				assignedNavigation = studentNavigation

				user.student.campuses.map
					(
						(campus: any) => {
							refIndex = "C_" + campus.id
							campusIndex[refIndex] = { ...campus, refIndex: refIndex }
						}
					)

				user.student.campusRef = campusIndex
			}
		}

		if (user.currentRole) {
			dispatch(setCurrentUserRole(user.currentRole))
			localStorage.setItem("currentRole", user.currentRole)

			if (user.currentRole == "student") {
				user.currentCampus = "C_" + user.student.campuses[0].id

				localStorage.setItem("currentCampus", user.currentCampus)
			}
			else {
				if (user.roleMap[user.currentRole].campuses.length > 0) {
					user.currentCampus = "C_" + user.roleMap[user.currentRole].campuses[0].id

					localStorage.setItem("currentCampus", user.currentCampus)
				}
			}
		}
		else {
			if (localStorage.getItem("currentRole") != null) {
				localStorage.removItem("currentRole")
			}

			if (localStorage.getItem("currentCampus") != null) {
				localStorage.removItem("currentCampus")
			}
		}

		dispatch(setCurrentUserRole(user.currentRole))
		dispatch(setCurrentUserCampus(user.currentCampus))
		dispatch(setCurrentUserCampusId(user.currentCampus ? campusIndex[user.currentCampus].id : null))
		dispatch(setCampusRef(campusIndex))

		menu?.forEach
			(
				(element: any, index: number) => {
					element.sections.forEach
						(
							(item: any, subIndex: number) => {
								menuMap[item.route] = element.block.group
							}
						)
				}
			)

		dispatch(setUserMenu(menu))
		dispatch(setMenuRef(menuMap))
		dispatch(setNavigation(assignedNavigation))
		dispatch(setSessionToken(data.accessToken))
		localStorage.setItem("accessToken", data.accessToken)
		anotarDuenoDelToken(data.user && data.user.id)
		marcarCambioDeClave(data.user)
		olvidarMotivoDeSalida()
		basicSetup(data, dispatch)
		// Producción: el login regresa al enlace guardado (wapp.volverA). Si esa ruta todavía no está en el menú (o el enlace trae
		// «rol=» de otro rol), la ruta desconocida manda a la portada y App la retoma con el destino de cobros (destinoTrasLogin).
		destino.current = destinoTrasEntrar()
		navigate(destino.current)
	}

	/*
		Sesión abierta (contraseña, código de WhatsApp o invitación): mismos pasos para los tres caminos.
	*/
	const entrarConDatos = (data: any) => {
		/*
			Alumno que entra en un navegador donde quedó la sesión del personal (compu del plantel): se borra TODO lo del
			personal guardado (rol, planteles, permisos), o la app seguía pidiendo cosas del rol anterior y salía el error
			"No se pudieron cargar los permisos del rol actual" (QA 2026-10-21).
		*/
		try { sessionStorage.removeItem("wapp.invitacion") } catch (_) { /* nada */ }
		if (!data?.user?.roles || data.user.roles.length === 0) {
			dispatch(handleLogout())
			dispatch(setPermissions([]))
		}
		access(data);

		// El servidor avisa cuando cerró la sesión más antigua por el
		// tope de dispositivos (Esteban, 2026-09-14). Sin rojo (look de WAPP, 2026-10-21).
		if (data.sessionNotice) {
			dispatch(displayNotice({
				cornerClose: true,
				message: data.sessionNotice,
				heading: <h3 style={{ color: "var(--wa-tinta)", display: "inline-block" }}>
					Aviso De Seguridad
				</h3>
			}))
		}

		const accessToken = data.accessToken;
		const user = data.user;
		dispatch(setUser({
			id: user.id,
			firstName: user.first_name,
			lastName: user.last_name,
			email: user.email,
			token: accessToken
		}));
		dispatch(setRoles(user.roles));
		//Un alumno no tiene rol del personal: initialRole llega nulo (Portal del alumno, 2026-10-16).
		if (user.initialRole) {
			dispatch(setCurrentRole(user.initialRole));
			dispatch(setAllowedCampuses(user.initialRole.campuses));
		}
	}

	const procedureComplaint = (message: string) => {
		dispatch
			(
				displayNotice
					({
						cornerClose: false,
						message: message,
						heading: <h3 style={{ color: "var(--wa-rojo-error)", display: "inline-block" }}>
							Error
						</h3>
					})
			)
	}

	const procedureNotice = (message: string) => {
		dispatch
			(
				displayNotice
					({
						cornerClose: false,
						message: message,
						heading: <h3 style={{ color: "var(--wa-tinta)", display: "inline-block" }}>
							Listo
						</h3>
					})
			)
	}

	const { handleSubmit, handleChange, data: user, errors } = useForm<User>
		({
			validations: {},
			onSubmit: () => {
				switch (currentTab) {
					case "login":
						if (!loginFormRef?.current?.checkValidity()) {
							loginFormRef?.current?.reportValidity()
						}
						else {
							dispatch(enableIdleLockSwitch())
							AuthService
								.login(user.email, user.password)
								.then
								(
									(result: any) => {
										if (result.data.elegir) {
											setSeleccion({ boleto: result.data.boleto, cuentas: result.data.cuentas || [] })
											setCurrentTab("elegir")
											return
										}
										entrarConDatos(result.data)
									},
									(error: any) => {
										console.log(error)

										// El servidor explica por qué cuando la clave fue restablecida
										// por seguridad o la cuenta está desactivada: se muestra su texto
										// en lugar del mensaje genérico (Esteban, 2026-09-14).
										const respuesta = error?.response
										const explicacion = respuesta?.data?.message

										//Alumno sin contraseña: a "Entrar Con WhatsApp", que la crea al final (2026-10-21).
										if (respuesta?.status === 403 && respuesta?.data?.error_code === "password_reset_required" && respuesta?.data?.whatsapp) {
											abrirWhatsapp("entrar", { aviso: explicacion })
											return
										}

										if (respuesta?.status === 403 && respuesta?.data?.error_code === "password_reset_required" && respuesta?.data?.codigo) {
											setCodigoInicial({ email: (user.email || "").trim(), aviso: explicacion })
											setCurrentTab("pwdCodigo")
											return
										}

										procedureComplaint
											(
												(respuesta?.status === 403 || respuesta?.status === 426 || respuesta?.status === 429) && explicacion
													? explicacion
													: respuesta?.status == 401
														? "Correo, número o contraseña incorrectos. Si aún no tienes contraseña, entra con WhatsApp."
														: "Revise el estado de la red y refresque la vista para volver a intentar"
											)
									}
								)
								.finally
								(
									() => {
										dispatch(disableIdleLockSwitch())
									}
								)
						}
						break;
					case "pwdReset":
						if (!pwdResetFormRef?.current?.checkValidity()) {
							pwdResetFormRef?.current?.reportValidity()
						}
						else {
							dispatch(enableIdleLockSwitch())
							AuthService
								.requestPasswordReset(recoverRef?.current?.value || "")
								.then
								(
									(result: any) => {
										procedureNotice(result.data.message)
										setCurrentTab("login")
									},
									(error: any) => procedureComplaint
										(
											error.response?.status == 429
												? "Ya se envió un correo hace poco. Espera un minuto antes de volver a intentar."
												: "Revise el estado de la red y refresque la vista para volver a intentar"
										)
								)
								.finally(() => dispatch(disableIdleLockSwitch()))
						}
						break;
					case "pwdResetConfirm":
						if (!pwdResetConfirmFormRef?.current?.checkValidity()) {
							pwdResetConfirmFormRef?.current?.reportValidity()
						}
						else if (user.password != user.passwordConfirm) {
							procedureComplaint("Las contraseñas no coinciden")
						}
						else {
							dispatch(enableIdleLockSwitch())
							AuthService
								.confirmPasswordReset(resetParams.token, resetParams.email, user.password, user.passwordConfirm)
								.then
								(
									(result: any) => {
										procedureNotice(result.data.message)
										window.history.replaceState({}, "", window.location.pathname)
										setResetParams({ token: "", email: "" })
										setCurrentTab("login")
									},
									(error: any) => procedureComplaint
										(
											error.response?.status == 422
												? (error.response.data?.message || "El enlace no es válido o ya expiró. Solicita uno nuevo.")
												: "Revise el estado de la red y refresque la vista para volver a intentar"
										)
								)
								.finally(() => dispatch(disableIdleLockSwitch()))
						}
						break;
				}
			}
		})

	useEffect
		(
			() => {
				loginTrigger
					({
						type: "setIsLoginButtonDisabled",
						payload: idleLocked
					})
			},
			[user.email, user.password]
		)

	useEffect
		(
			() => {
				registerTrigger
					({
						type: "setIsRegisterButtonDisabled",
						payload: !(registerFormRef?.current?.checkValidity() && !idleLocked) || (user.password != user.passwordConfirm)
					})
			},
			[user.email, user.password, user.passwordConfirm]
		)

	useEffect
		(
			() => {
				pwdResetTrigger
					({
						type: "setIsPwdResetButtonDisabled",
						payload: !(pwdResetFormRef?.current?.checkValidity() && !idleLocked)
					})
			},
			[user.email]
		)

	const handleClose = () => setShow(false)
	const focusElement = (event: FocusEvent) => {
		if (loginRef != null && loginRef.current != null) {
			const elementId: string = event.currentTarget.id
			setFocusedElement(elementId)

			validateField(event)
		}
	}

	const selectInput = (focusInput: RefObject<HTMLDivElement>, focusLabel: RefObject<HTMLLabelElement>) => {
		if (divUserNoExist.current != null) {
			divUserNoExist.current.className = "displayNone hidden";
		}

		if (focusLabel.current != null) {
			focusLabel.current.classList.remove("hidden")
		}

		if (focusInput.current != null) {
			focusInput.current.className = "selectInput focusInputBar";
		}
	}

	const deselectInput = (focusInput: RefObject<HTMLDivElement>, focusLabel: RefObject<HTMLLabelElement>) => {
		if (divUserNoExist.current != null) {
			divUserNoExist.current.className = "displayNone hidden";
		}

		if (focusLabel.current != null) {
			focusLabel.current.classList.toggle("hidden");
		}

		/*
			Al salir del campo esto encendia la barra naranja en vez de apagarla, y
			como el blur no provoca un repintado, la barra se quedaba prendida en un
			campo que ya nadie estaba escribiendo.
		*/
		if (focusInput.current != null) {
			focusInput.current.className = "";
		}
	}

	const formSubmission = (event: FormEvent) => {
		event.preventDefault()
		handleSubmit()
	}

	if (authenticated) {
		return <Navigate to={destino.current || destinoTrasEntrar()} replace />
	}

	return <div className="login">
		<Modal show={show} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Advertencia</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				Hubo un problema con extraer la información, intente refrescar la página
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={handleClose} type="button">
					Cerrar
				</Button>
				<Button className="btnModal" variant="primary" onClick={handleClose} type="button">
					Aceptar
				</Button>
			</Modal.Footer>
		</Modal>
		<div className="loginContent">
			<div className="loginForm">
				<div className="loginFormLeft">
					<div className="logo" />
					<Tabs defaultActiveKey="login" activeKey={currentTab!!} onSelect={setCurrentTab}
						id="uncontrolledTabExample" className="mb-3 hidden displayNone"
					>
						<Tab eventKey="login" title="">
							<form ref={loginFormRef} className="form" onSubmit={formSubmission}>
								<h1 className="pageHeader">
									Bienvenido
								</h1>
								<div ref={divUserNoExist} className="displayNone hidden"><span>
									Verifica que tu correo o contraseña sean correctos
								</span></div>
								<div className="divInput">
									<div ref={focusInputEmail} className={focusedElement == "email" ? "focusInputBar" : ""}>
									</div>
									<label className={focusedElement != "email" ? "hidden" : ""} htmlFor="email"
										ref={focusLabelEmail}
									>
										Correo o WhatsApp
									</label>
									<input
										name="email"
										ref={emailRef}
										id="email"
										type="text"
										inputMode="email"
										autoCapitalize="none"
										autoComplete="username"
										placeholder="Correo o número de WhatsApp"
										onChange={handleChange("email")} value={user.email || ""}
										disabled={idleLocked}
										onKeyPress={(event: any) => keyHandling(!loginState.isLoginButtonDisabled && event, loginRef)}
										onFocus={focusElement}
										onBlur={() => deselectInput(focusInputEmail, focusLabelEmail)}
										required
									>
									</input>
								</div>
								<div className="divInput">
									<div ref={focusInputPass} className={focusedElement == "password" ? "focusInputBar" : ""} />
									<label htmlFor="password" ref={focusLabelPass}
										className={(focusedElement != "password" && isEmpty(passwordRef?.current?.value)) ? "hidden" : ""}
									>
										Contraseña
									</label>
									<input
										name="password"
										ref={passwordRef}
										value={user.password || ""}
										disabled={idleLocked}
										placeholder="Contraseña"
										onChange={handleChange("password")} id="password"
										type="password"
										onKeyPress={(event: any) => keyHandling(!loginState.isLoginButtonDisabled && event, loginRef)}
										onFocus={focusElement}
										required
									/>
								</div>
								<br />
								<div className="forgotOrRemember">
									<div className="forgotPassword">
										<a onClick={() => { if (!idleLocked) { setCodigoInicial(null); setCurrentTab("pwdCodigo") } }}>
											Olvidé Mi Contraseña
										</a>
									</div>
								</div>
								{/* Aqui habia un boton "Registrarse". Las cuentas de WAPP las da de alta
								    el personal de la academia, nadie se registra solo, asi que el boton
								    llevaba a una pantalla que no debia existir. */}
								<div className="loginButtons">
									<input className="btn btnPurple rounded-pill" value="Iniciar Sesión" disabled={idleLocked}
										style={{ width: "auto" }} type="submit" ref={loginRef}
									/>
								</div>
								{/* Alumnos: entrar con un código a su WhatsApp, sin correo ni contraseña (2026-10-21). */}
								<div className="accOtraForma">
									<button type="button" className="accBotonWa" disabled={idleLocked} onClick={() => abrirWhatsapp("entrar")}>
										Entrar Con WhatsApp
									</button>
								</div>
							</form>
						</Tab>
						{/* Se quito la pestaña "Registrate". Nadie crea su propia cuenta en
						    WAPP: las altas las hace el personal desde el modulo de alumnos o
						    el de personal. */}
						<Tab eventKey="pwdReset" title="">
							<form ref={pwdResetFormRef} onSubmit={formSubmission} className="form">
								<h2 className="h1">
									Recuperar contraseña
								</h2>
								<p>
									Escribe tu correo de WAPP y te mandamos un enlace para cambiar la contraseña. Llega a ese correo y también a tu correo personal, si lo diste de alta.
								</p>
								<div ref={divUserNoExist} className="displayNone hidden">
									<span>
										Verifica que tu correo o contraseña sean correctos
									</span>
								</div>
								<div className="divInput">
									<div ref={focusInputRecover}
										className={focusedElement == "emailForgot" ? "focusInputBar" : ""}
									/>
									<label ref={focusLabelRecover} className="hidden" htmlFor="">
										Correo
									</label>
									<input
										ref={recoverRef}
										placeholder="Correo"
										id="emailForgot"
										disabled={idleLocked}
										onChange={validateField}
										onBlur={() => deselectInput(focusInputRecover, focusLabelRecover)}
										onKeyPress={(event: any) => keyHandling(!loginState.isLoginButtonDisabled && event, pwdResetRef)}
										required
										onFocus={focusElement}
										type="email"
									/>
								</div>
								<div className="forgotButton">
									<button
										className="btn btnPurple rounded-pill"
										disabled={idleLocked}
										ref={pwdResetRef}
										style={{ width: "auto" }}
										type="submit"
									>
										Enviar correo
									</button>
								</div>
								<div className="logInLink">
									<a onClick={() => { if (!idleLocked) { setCodigoInicial(null); setCurrentTab("pwdCodigo") } }}>
										Recibir un código por WhatsApp
									</a>
									&nbsp;·&nbsp;
									<a onClick={() => { !idleLocked && setCurrentTab("login") }}>
										Iniciar Sesión
									</a>
								</div>
							</form>
						</Tab>
						<Tab eventKey="whatsapp" title="">
							{currentTab !== "whatsapp" ? null : <EntrarConWhatsApp
								key={"wa" + whatsapp.n}
								modo={whatsapp.modo}
								telefonoInicial={whatsapp.telefono}
								paisInicial={whatsapp.pais}
								avisoInicial={whatsapp.aviso}
								alEntrar={entrarConDatos}
								alVolver={() => setCurrentTab("login")}
							/>}
						</Tab>
						<Tab eventKey="elegir" title="">
							{currentTab !== "elegir" || !seleccion ? null : <ElegirCuenta
								seleccion={seleccion}
								alEntrar={entrarConDatos}
								alVolver={() => { setSeleccion(null); setCurrentTab("login") }}
							/>}
						</Tab>
						<Tab eventKey="invitacion" title="">
							{currentTab !== "invitacion" || !invitacion ? null : <Invitacion
								token={invitacion}
								alEntrar={entrarConDatos}
								alNoSirve={(aviso, telefono, pais) => { try { sessionStorage.removeItem("wapp.invitacion") } catch (_) { /* nada */ } abrirWhatsapp("entrar", { aviso, telefono, pais }) }}
							/>}
						</Tab>
						<Tab eventKey="pwdCodigo" title="">
							{currentTab !== "pwdCodigo" ? null : <RecuperarPorCodigo
								key={codigoInicial ? "auto" : "pedir"}
								emailInicial={codigoInicial?.email}
								avisoInicial={codigoInicial?.aviso}
								alTerminar={(mensaje) => { procedureNotice(mensaje); setCodigoInicial(null); setCurrentTab("login") }}
								alVolver={() => { setCodigoInicial(null); setCurrentTab("login") }}
								alPorTelefono={() => abrirWhatsapp("olvide")}
							/>}
						</Tab>
						<Tab eventKey="pwdResetConfirm" title="">
							<form ref={pwdResetConfirmFormRef} onSubmit={formSubmission} className="form">
								<h2 className="h1">
									Nueva contraseña
								</h2>
								<p>
									Escribe la nueva contraseña para la cuenta <strong>{resetParams.email}</strong> (mínimo 8 caracteres).
								</p>
								<div className="divInput">
									<div className={focusedElement == "newPassword" ? "focusInputBar" : ""} />
									<label htmlFor="newPassword"
										className={(focusedElement != "newPassword" && isEmpty(user.password)) ? "hidden" : ""}
									>
										Nueva contraseña
									</label>
									<input
										name="password"
										id="newPassword"
										value={user.password || ""}
										onChange={handleChange("password")}
										placeholder="Nueva contraseña"
										type="password"
										minLength={8}
										maxLength={50}
										disabled={idleLocked}
										onFocus={(e) => setFocusedElement(e.target.id)}
										onKeyPress={(event: any) => keyHandling(event, pwdResetConfirmRef)}
										required
									/>
								</div>
								<div className="divInput">
									<div className={focusedElement == "newPasswordConfirm" ? "focusInputBar" : ""} />
									<label htmlFor="newPasswordConfirm"
										className={(focusedElement != "newPasswordConfirm" && isEmpty(user.passwordConfirm)) ? "hidden" : ""}
									>
										Confirmar contraseña
									</label>
									<input
										name="passwordConfirm"
										id="newPasswordConfirm"
										value={user.passwordConfirm || ""}
										onChange={handleChange("passwordConfirm")}
										placeholder="Confirmar contraseña"
										type="password"
										minLength={8}
										maxLength={50}
										disabled={idleLocked}
										onFocus={(e) => setFocusedElement(e.target.id)}
										onKeyPress={(event: any) => keyHandling(event, pwdResetConfirmRef)}
										required
									/>
								</div>
								<div className="forgotButton">
									<input
										className="btn btnPurple rounded-pill"
										disabled={idleLocked}
										ref={pwdResetConfirmRef}
										style={{ width: "auto" }}
										type="submit"
										value="Guardar contraseña"
									/>
								</div>
								<div className="logInLink">
									<a onClick={() => { !idleLocked && setCurrentTab("login") }}>
										Iniciar Sesión
									</a>
								</div>
							</form>
						</Tab>
					</Tabs>
				</div>
				<div className="loginFormRight" />
			</div>
		</div>
	</div>
}

export default Access;
